const API_URL = "https://metagent-studio-be.infidea.dev/api/articles";
const IMAGE_BASE_URL = "https://metagent-studio-be.infidea.dev/uploads";

const formatPublishDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const normalizeArticle = (article) => {
  const metaEn = article?.meta?.en || {};
  const metaId = article?.meta?.id || {};
  const category =
    article?.category?.name ||
    article?.category?.title ||
    article?.category?.slug ||
    article?.category ||
    "All";

  return {
    id: article?.id,
    slug: article?.slug,
    title: metaEn.title || "",
    titleId: metaId.title || metaEn.title || "",
    description: metaEn.description || "",
    descriptionId: metaId.description || metaEn.description || "",
    content: metaEn.content || "",
    contentId: metaId.content || metaEn.content || "",
    image: article?.image ? `${IMAGE_BASE_URL}/${article.image}` : "",
    date: formatPublishDate(article?.published_at),
    category,
  };
};

export const fetchArticles = async () => {
  const res = await fetch(API_URL);
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  const data = await res.json();
  if (!Array.isArray(data)) return [];
  return data.map(normalizeArticle);
};
